<div class="numpad-keys" [ngClass]="{ 'hide-confirm': !numpadService.keypadOptions.showConfirm }">
    <button class="one" tabindex="-1" (click)="tap('1')">1</button>
    <button class="four" tabindex="-1" (click)="tap('4')">4</button>
    <button class="seven" tabindex="-1" (click)="tap('7')">7</button>
    <button class="zero" tabindex="-1" (click)="tap('0')">0</button>
    <button class="two" tabindex="-1" (click)="tap('2')">2</button>
    <button class="five" tabindex="-1" (click)="tap('5')">5</button>
    <button class="eight" tabindex="-1" (click)="tap('8')">8</button>
    <button class="three" tabindex="-1" (click)="tap('3')">3</button>
    <button class="six" tabindex="-1" (click)="tap('6')">6</button>
    <button class="nine" tabindex="-1" (click)="tap('9')">9</button>
    <button class="separator" tabindex="-1" (click)="tap(separator)">{{ separator }}</button>
    <button ds-button-icon kind="tertiary" variant="flat-reduced" size="medium" class="delete delete-icon" tabindex="-1" (click)="remove()">
        <vn-icon name="theme-delete-i" />
    </button>
    @if (numpadService.keypadOptions.showConfirm) {
        <button class="ok" tabindex="-1" (click)="ok()">
            <span>{{ sitecore.betslip.numpad.Ok }}</span>
        </button>
    }
</div>
